import React, { useState } from 'react'
import { Field, Formik, Form } from 'formik'
import { securitySettingsSchema } from './schema/security_settings.schema';
import { Input } from '../../../../ui/forms/formik';
import { Button } from 'react-bootstrap';
import AlertModal from '../../../../ui/modals/AlertModal';

const SecuritySettingsForm = () => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Formik
                initialValues={{ currentPassword: '', newPassword: '', confirmPassword: '' }}
                validationSchema={securitySettingsSchema}
                onSubmit={(values, actions) => {
                    console.log(actions, values);
                    
                    setShowModal(true);
                    alert(JSON.stringify(values, null, 2));
                }}
                validateOnMount
            >{(props) => (
                    <Form className="formik">
                        <h6 className="form-group-title">Change Password</h6>
                        <Field
                            name="currentPassword"
                            type="password"
                            label="Current Password"
                            placeholder="Enter Current Password"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                        <Field
                            name="newPassword"
                            type="password"
                            label="New Password"
                            placeholder="Enter New Password"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                        <Field
                            name="confirmPassword"
                            type="password"
                            label="Confirm Password"
                            placeholder="Re-Enter New Password"
                            component={Input}
                            className="input input-flat input-xl"
                        />
                        <Button type="submit" variant="primary" disabled={!(props.isValid && props.dirty)} className="align-right lg" size="xl">Update Password</Button>
                    </Form>
                )}
            </Formik>
            <AlertModal
                size="sm"
                show={showModal}
                onHide={() => setShowModal(false)}
                icon={require('../../../../../assets/svg/ils/ils-check.svg')}
                message="Password Changed"
                subtitle="Your account password has been updated sucessfully"
                btnText="Ok, Thanks"
                btnProps={{ variant: "link" }}
                className="success-modal"
            />
        </>
    )
}

export default SecuritySettingsForm
